import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environment/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsService {
  isMapsLoaded = false;

  load(): Observable<void> {
    return new Observable<void>(subscriber => {
      const script = document.createElement('script');
      const params = new URLSearchParams({
        key: environment.googleMapsApiKey,
        callback: 'initMap',
        libraries: 'marker',
      });

      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      script.async = true;
      script.defer = true;

      (window as unknown as { initMap: () => void }).initMap = (): void => {
        this.isMapsLoaded = true;
        subscriber.next();
        subscriber.complete();
      };

      script.onerror = (): void => {
        subscriber.error(new Error('Failed to load Google Maps'));
      };

      document.head.appendChild(script);
    });
  }
}
